import * as React from 'react';
import styled from 'styled-components';

export interface Props {
  style: React.CSSProperties;
  onClick: (event: React.MouseEvent<HTMLOrSVGElement>) => void;
}

const Svg = styled.svg`
  &:hover {
    cursor: pointer;
  }
`;

export const IconClose = (props: Props) => {
  const { onClick, style } = props;
  return (
    <Svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="14.7 14.7 20.7 20.7"
      onClick={onClick}
    >
      <g>
        {/* <circle fill="#fff" cx="25" cy="24.9" r="8.8" /> */}
        <polygon points="19,29.2 23.3,24.9 19,20.5 20.6,18.9 25,23.2 29.4,18.9 31,20.5 26.7,24.9 31,29.2 29.4,30.9 25,26.5 20.6,30.9" />
      </g>
    </Svg>
  );
};
